import PropTypes from 'prop-types';
// @mui
import AddCircle from '@mui/icons-material/AddCircle';
import { useTheme, styled, Box, Button } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

interface Props {
  children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
  onClick?: any;
  size: number;
  inline?: boolean;
}

export const AddButton = (props: Props) => {
  const theme = useTheme();
  return (
    <AddCircle
      onClick={props.onClick}
      sx={{
        width: props.size + 'px',
        height: props.inline ? '100%' : props.size + 'px',
        color: theme.palette.root.brandPrimary,
        cursor: 'pointer',
      }}
    />
  );
};

type exrtaProps = {
  height?: string;
  autoheight?: string;
  autowidth?: string;
};

export const GeneralButton = styled(Box)<exrtaProps>((props) => ({
  '& .MuiButtonBase-root': {
    fontSize: '15px',
    minWidth: 'auto',
    fontFamily: 'RubikMedium',
    height: props.height || '48px',
  },
}));

export const FormButton = styled(Box)<exrtaProps>((props) => ({
  '& .MuiButton-outlined': {
    fontSize: '15px',
    textTransform: 'unset !important',
    minWidth: props?.autowidth ? 'auto!important' : '156px',
    height: props?.autoheight ? 'auto!important' : '48px',
    fontWeight: 'normal',
    border: '1px solid ' + props.theme.palette.root.darkGrayed,
    '&.whithBg': {
      backgroundColor: props.theme.palette.root.basicWhite + '!important',
    },
    '&.Mui-disabled': {
      border: '1px solid #cbdcde'
    }
  },
  '& .MuiButtonBase-root': {
    height: '48px',
    fontSize: '15px',
    textTransform: 'unset !important',
    minWidth: '156px',
    fontWeight: 'normal',

    '&.MuiButton-contained:hover': {
      backgroundColor: props.theme.palette.root.basicDeepGreen,
    },
    '&.MuiButton-contained:focus': {
      backgroundColor: props.theme.palette.root.basicDeepGreen,
    },
  },
  '& .singleFormButton': {
    width: '70%',
    margin: '0 15%',
    [props.theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: 0,
    },
  },
}));

export const SelectBoxButton = styled(Box)((props) => ({
  '& .MuiButtonBase-root': {
    height: '32px',
    fontSize: '14px',
    [props.theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    fontWeight: 'normal',
    border: '1px solid #cbdcde',
    boxShadow: 'none',
    borderRadius: '16px',
    color: 'inherit',
    whiteSpace: 'nowrap',
    '&.MuiButton-contained': {
      backgroundColor: props.theme.palette.root.basicWhite,
      '&.selectedItems': {
        backgroundColor: props.theme.palette.root.brandPrimary_008,
        borderColor: props.theme.palette.root.brandSecondary + '!important',
      },
    },
    '&.MuiButton-contained:hover': {
      backgroundColor: props.theme.palette.root.basicWhite,
      borderColor: props.theme.palette.root.brandSecondary + '!important',
      boxShadow: 'none',
    },
    '&.MuiButton-contained:focus': {
      backgroundColor: props.theme.palette.root.basicWhite,
      '&.selectedItems': {
        backgroundColor: props.theme.palette.root.brandPrimary_008,
        borderColor: props.theme.palette.root.brandSecondary + '!important',
      },
    },
  },
}));

export const SearchBoxSeperator = styled(Box)((props) => ({
  width: '1.2px',
  background: props.theme.palette.root.darkGrayed + '!important',
}));

export const SearchButton = styled(Box)((props) => ({
  [props.theme.breakpoints.down('sm')]: {
    width: '100%',
    display: 'block',
  },
  '& .MuiInputBase-root': {
    [props.theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    height: '32px',
    fontSize: '15px',
    fontWeight: 'normal',
    border: '1px solid ' + props.theme.palette.root.darkGrayed,
    boxShadow: 'none',
    borderRadius: '16px',
    color: 'inherit',
    '&.Mui-focused': {
      boxShadow: 'none',
    },
    '&.MuiButton-contained': {
      backgroundColor: props.theme.palette.root.basicWhite,
    },
    '&.MuiButton-contained:hover': {
      backgroundColor: props.theme.palette.root.basicWhite,
    },
    '&.MuiButton-contained:focus': {
      backgroundColor: props.theme.palette.root.basicWhite,
    },
  },
}));

export const EditButton = (props: { handleClick: any; label?: string }) => {
  const t = useAppSelector(selectTranslations);
  const theme = useTheme();
  return (
    <Button
      onClick={props.handleClick}
      variant="text"
      sx={{
        width: '55px',
        padding: '5px',
        borderRadius: '4px',
        textAlign: 'center',
        color: theme.palette.root.basicDeeoGreen,
        cursor: 'pointer',
        fontWeight: 'normal',
        '&:hover': {
          backgroundColor: theme.palette.root.backgroundGreen,
          color: theme.palette.root.brandSecondary,
        },
      }}
    >
      {props.label || 'Edit'}
    </Button>
  );
};
interface childrenProps {
  children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
}

export const TableActionRowButton = (props: childrenProps) => {
  const theme = useTheme();
  return (
    <Box
      className="!hiddenActions"
      sx={{
        borderRadius: '10px',
        textAlign: 'center',
        lineHeight: '40px',
        marginTop: '-8px!important',
        marginBottom: '-8px!important',
        [theme.breakpoints.up('sm')]: { backgroundColor: 'rgba(255, 255, 255, 0.48)' },
        cursor: 'pointer',
        alignContent: 'center',
        flexWrap: 'wrap',
        display: 'flex',
        padding: '8px',
        '& svg': {
          color: theme.palette.root.basicDeeoGreen,
        },
      }}
    >
      {props.children}
    </Box>
  );
};
